// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1vxSI","notes":"Notes_notes__gbx7-"};